import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseOfferBlock } from '../blocks.types'

export const CollectionGridBlockFragment: BlockFragment = {
  name: 'collectionGrid',
  fragment: gql`
    fragment collectionGrid on CollectionGrid {
      id
      blockName
      blockType
      collectionGridHeading: heading
      collection {
        id
        name
      }
      limit
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on CollectionGrid {
      id
      blockName
      blockType
      collectionGridHeading:heading
      collection {
        id
        name
      }
      limit
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const CollectionGridBlockType = 'collectionGrid'

export interface CollectionGridBlock extends BaseOfferBlock {
  blockType: typeof CollectionGridBlockType
  collectionGridHeading: string
  collection: {
    id: string
    name: string
  }
  limit: number
  imagePriority?: boolean
}
